export const ROOM_SWITCH_TYPES = {
  PASSWORD: "isRequirePassword",
  MINIMUM_BALANCE: "isRequireMinimumBalance",
};
